import { render, staticRenderFns } from "./pageTitle.vue?vue&type=template&id=6be4c0e3&scoped=true&"
import script from "./pageTitle.vue?vue&type=script&lang=js&"
export * from "./pageTitle.vue?vue&type=script&lang=js&"
import style0 from "./pageTitle.vue?vue&type=style&index=0&id=6be4c0e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be4c0e3",
  null
  
)

export default component.exports